import Vue from 'vue'
import VueRouter from "vue-router";


Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
        routes: [
            
        {
            path: '/constructor', component: () => import('./components/editor/Index'),
            name: 'constructor.index',
            meta: {
                title: 'Контструктор',
            }
        },
            {
            path: '/editor/pmask', component: () => import('./components/modal/media/Editor_pmask'),
            name: 'editor.pmask',
            meta: {
                title: 'Редактор фото',
            }
        },
        {
            path: '/certificate', component: () => import('./components/app/Certificate'),
            name: 'certificate.index',
            meta: {
                title: 'Активация сертификата',
            }
        },
         {
            path: '/about', component: () => import('./components/app/About'),
            name: 'about.index',
            meta: {
                title: 'О нас',
            }
        },
        {
            path: '/events', component: () => import('./components/event/Index'),
            name: 'events.index',
            meta: {
                title: 'События',
            }
        },
        {
            path: '/faq', component: () => import('./components/faq/Index'),
            name: 'faq.index',
            meta: {
                title: 'Помощь по приложению',
            }
        },
            //kinder
        {
            path: '/kinder', component: () => import('./components/kinder/Index'),
            name: 'kinder.index',
            meta: {
                title: 'Главная страница',
            }
        },
         {
            path: '/kinder/groups', component: () => import('./components/kinder/Groups'),
            name: 'kinder.groups',
            meta: {
                title: 'Группы',
            }
        },
         {
            path: '/kinder/groups/:id', component: () => import('./components/kinder/GroupChildren'),
            name: 'kinder.groups.show',
            meta: {
                title: 'Список детей',
            }
        },
         {
            path: '/kinder/jurnal', component: () => import('./components/kinder/Online'),
            name: 'kinder.jurnal.index',
            meta: {
                title: 'Журнал посещений',
            }
        },
        {
            path: '/kinder/menu', component: () => import('./components/kinder/Menu'),
            name: 'kinder.menu.index',
            meta: {
                title: 'Меню в столовой',
            }
        },
        {
            path: '/kinder/wallet', component: () => import('./components/kinder/Wallet'),
            name: 'kinder.wallet.index',
            meta: {
                title: 'Кошелек',
            }
        },
        {
            path: '/kinder/lessons', component: () => import('./components/kinder/Lessons'),
            name: 'kinder.lessons.index',
            meta: {
                title: 'Занятия',
            }
        },
        {
            path: '/kinder/daily', component: () => import('./components/kinder/Daily'),
            name: 'kinder.daily.index',
            meta: {
                title: 'Режим дня',
            }
        }, 
        {
            path: '/kinder/users/all', component: () => import('./components/kinder/Users'),
            name: 'kinder.all.users',
            meta: {
                title: 'Кабинет управления',
            }
        },
        {
            path: '/cabinet', component: () => import('./components/user/Cabinet'),
            name: 'cabinet.index',
            meta: {
                title: 'Кабинет управления',
            }
        },
        {
            path: '/kinder/content', component: () => import('./components/kinder/Contents'),
            name: 'kinder.content',
            meta: {
                title: 'Ленты',
            }
        },
            //kinder-end
        {
            path: '/', component: () => import('./components/Newindex'),
            name: 'main.index',
            meta: {
                title: 'Приложение',
            }
        },
        {
            path: '/menu', component: () => import('./components/Baby'),
            name: 'menu.index',
            meta: {
                title: 'Приложение',
            }
        },
        {
            path: '/menu/:type', component: () => import('./components/services/Kinder_select'),
            name: 'menu.kinder.group',
            meta: {
                title: 'Выбор группы',
            }
        },
        {
            path: '/contacts', component: () => import('./components/app/Contacts.vue'),
            name: 'contacts.index',
            meta: {
                title: 'Контакты',
            }
        },
// {
//     path: '/',
//     component: {
//       render(h) {
//         const isMobile = window.innerWidth < 768; // Проверка на мобильное устройство
//         const componentToRender = (isMobile || platform_type === 'baby') 
//           ? () => import('./components/Baby') // Используем Babyindex для мобильной версии
//           : () => import('./components/Newindex'); // Используем Index для десктопной версии

//         return h(componentToRender); // Рендерим выбранный компонент
//       }
//     },
//     name: 'main.index',
//     meta: {
//                 title: 'Приложение',
//     }
//   },
        {
            path: '/new', component: () => import('./components/Newindex'),
            name: 'new.index',
            meta: {
                title: 'Приложение',
            }
        },
        // {
        //     path: '/feed', component: () => import('./components/feed/Index'),
        //     name: 'feed.index',
        //     meta: {
        //         title: 'Ленты',
        //     }
        // },
        {
            path: '/lents', component: () => import('./components/lenta/Index'),
            name: 'lenta.index',
            meta: {
                title: 'Ленты',
            }
        },
         {
            path: '/password/reset/:token', component: () => import('./components/user/Password'),
            name: 'user.password.reset',
            meta: {
                title: 'Забыли пароль',
            }
        },
        {
            path: '/password/send', component: () => import('./components/user/Reset'),
            name: 'user.password.send',
            meta: {
                title: 'Забыли пароль',
            }
        },
        {
            path: '/login', component: () => import('./components/user/Login'),
            name: 'user.login',
            meta: {
                title: 'Авторизация',
            }
        },
        {
            path: '/qr.auth', component: () => import('./components/user/Qr_auth'),
            name: 'qr.login',
            meta: {
                title: 'Авторизация через qr',
            }
        },
        {
            path: '/signup', component: () => import('./components/user/Signup'),
            name: 'user.signup',
            meta: {
                title: 'Регистрация',
            }
        },
         {
            path: '/u/wallet', component: () => import('./components/user/Wallet'),
            name: 'user.wallet.index',
            meta: {
                title: 'Кошелек',
            }
        },
        {
            path: '/u/:uid', component: () => import('./components/user/Profile'),
            name: 'user.profile',
            props: true,
            meta: {
                title: 'Профиль',
            }
        },
        {
            path: '/u/:uid/referrals', component: () => import('./components/user/Referrals'),
            name: 'user.referal',
            props: true,
            meta: {
                title: 'Реферальная система',
            }
        },
        {
            path: '/edit', component: () => import('./components/user/Edit'),
            name: 'user.edit',
            props: true,
            meta: {
                title: 'Редактирование профиля',
            }
        },
        {
            path: '/user/disk', component: () => import('./components/user/Disk'),
            name: 'user.disk',
            meta: {
                title: 'Диск',
            }
        },
        {
            path: '/lenta/:id', component: () => import('./components/lenta/View'),
            name: 'lenta.view',
            props: true,
            meta: {
                title: 'Лента',
            }
        },
        {
            path: '/lents/:id', component: () => import('./components/lenta/Index'),
            name: 'lenta.show.category',
            props: true,
            meta: {
                title: 'Лента',
            }
        },
        {
            path: '/episode/:id', component: () => import('./components/episode/Show'),
            name: 'episode.show',
            meta: {
                title: 'Эпизод',
            }
        },
        {
            path: '/editor', component: () => import('./components/episode/Editor'),
            name: 'editor.show',
            meta: {
                title: 'Редактор',
            }
        },
        {
            path: '/content', component: () => import('./components/lenta/Content'),
            name: 'lenta.content',
            meta: {
                title: 'Контент',
            }
        },
         {
            path: '/mvoice', component: () => import('./components/messenger/modules/Voice'),
            name: 'voice.index',
            meta: {
                title: 'Аудиосообщения',
            }
        },
        {
            path: '/messenger/business', component: () => import('./components/messenger/Bus'),
            name: 'business.index',
            meta: {
                title: 'Бизнес-чаты',
            }
        },
        {
            path: '/messenger/business/:id', component: () => import('./components/messenger/Bus'),
            name: 'business.open',
            props: true,
            meta: {
                title: 'Бизнес чат',
            }
        },
        {
            path: '/messenger/b/:istype', component: () => import('./components/messenger/Bus'),
            name: 'business.istype.index',
            props: true,
            meta: {
                title: 'Мессенджер',
            }
        },
        {
            path: '/messenger/b/:istype/:id', component: () => import('./components/messenger/Bus'),
            name: 'business.istype.open',
            props: true,
            meta: {
                title: 'Мессенджер',
            }
        },
        {
            path: '/messenger', component: () => import('./components/messenger/Index'),
            name: 'messenger.index',
            meta: {
                title: 'Мессенджер',
            }
        },
        {
            path: '/messenger/:id', component: () => import('./components/messenger/Index'),
            name: 'messenger.open',
            props: true,
            meta: {
                title: 'Мессенджер',
            }
        },
        {
            path: '/services', component: () => import('./components/services/Index'),
            name: 'services.index',
            meta: {
                title: 'Сервисы',
            }
        },
        {
            path: '/store', component: () => import('./components/store/Index'),
            name: 'store.index',
            meta: {
                title: 'Каталог компаний',
            }
        },
        {
            path: '/store/category/:id', component: () => import('./components/store/Category'),
            name: 'store.show.category',
            meta: {
                title: 'Католог компаний',
            }
        },
        {
            path: '/store/show/:id', component: () => import('./components/store/ShowOLD'),
            name: 'store.pc.show',
            meta: {
                title: 'Католог компаний',
            }
        },
        {
            path: '/store/:id', component: () => import('./components/store/Show'),
            name: 'store.show',
            meta: {
                title: 'Католог компаний',
            }
        },
        {
            path: '/videoguide', component: () => import('./components/Videoguide'),
            name: 'videoguide',
            meta: {
                title: 'Видео гайд',
            }
        },
        {
            path: '/app', component: () => import('./components/app/Index'),
            name: 'app.index',
            meta: {
                title: 'Собственное приложение',
            }
        }, 
        {
            path: '/shop/product/:id', component: () => import('./components/shop/Product_show'),
            name: 'shop.product.show',
            props: true,
            meta: {
                title: 'Продуктовый магазин',
            }
        },
        {
            path: '/shop/category/:id', component: () => import('./components/shop/Show_category'),
            name: 'shop.category.show',
            props: true,
            meta: {
                title: 'Продуктовый магазин',
            }
        },
        {
            path: '/shop/category/:id/:subid', component: () => import('./components/shop/Show_category'),
            name: 'shop.subcategory.show',
            props: true,
            meta: {
                title: 'Продуктовый магазин',
            }
        },
        {
            path: '/shop/cart', component: () => import('./components/shop/Cart_order'),
            name: 'cart.shop.order',
            meta: {
                title: 'Заказ в продуктовом магазине',
            }
        },
        {
            path: '/shop', component: () => import('./components/shop/Newindex'),
            name: 'shop.index',
            meta: {
                title: 'Продуктовый магазин',
            }
        },
        {
            path: '/shop/categories', component: () => import('./components/shop/Allcats'),
            name: 'shop.all.categories',
            meta: {
                title: 'Продуктовый магазин',
            }
        },
        {
            path: '/shop/cat/:id', component: () => import('./components/shop/Show_category'),
            name: 'shop.cat.show',
            props: true,
            meta: {
                title: 'Продуктовый магазин',
            }
        },
         {
            path: '/goods', component: () => import('./components/markets/Goods'),
            name: 'goods.index',
            meta: {
                title: 'Список товаров',
            }
        },
        {
            path: '/market/:marketid?', component: () => import('./components/markets/Market'),
            name: 'market.index',
            props: true,
            meta: {
                title: 'Интернет-магазин',
            }
        },
        {
            path: '/trc/panel.scans', component: () => import('./components/markets/Panel'),
            name: 'tc.panel.scans',
            props: true,
            meta: {
                title: 'Управление сертификатами',
            }
        },
        {
            path: '/trc/panel.scans/certificate', component: () => import('./components/markets/modules/Certificates'),
            name: 'tc.panel.certificate',
            props: true,
            meta: {
                title: 'Список сертификатов',
            }
        },
        {
            path: '/trc/panel.scans/create.product', component: () => import('./components/markets/modules/CreateProduct'),
            name: 'tc.panel.scans.create.product',
            props: true,
            meta: {
                title: 'Добавление товара',
            }
        },
         {
            path: '/trc/panel.scans/products', component: () => import('./components/markets/modules/Product_lists'),
            name: 'tc.panel.scans.products',
            props: true,
            meta: {
                title: 'Товары',
            }
        },
         {
            path: '/tc', component: () => import('./components/markets/Markets'),
            name: 'tc.index',
            props: true,
            meta: {
                title: 'Список магазинов',
            }
        },
        {
            path: '/markets/seller/:marketid', component: () => import('./components/markets/Market'),
            name: 'markets.seller',
            meta: {
                title: 'Селлер интернет-магазина',
            }
        },
        {
            path: '/markets', component: () => import('./components/markets/Index'),
            name: 'markets.index',
            meta: {
                title: 'Маркетплейс',
            }
        },
        {
            path: '/markets/product/:id', component: () => import('./components/markets/Product_show'),
            name: 'markets.product.show',
            props: true,
            meta: {
                title: 'Товар',
            }
        },
        {
            path: '/markets/category/:id', component: () => import('./components/markets/Category'),
            name: 'markets.category.show',
            props: true,
            meta: {
                title: 'Категории товаров',
            }
        },
        {
            path: '/bs/catalogs', component: () => import('./components/bs/Index'),
            name: 'bs.index',
            meta: {
                title: 'Салон красоты каталог',
            }
        },
        {
            path: '/vk/callback', component: () => import('./components/services/Vkauth'),
            name: 'vk.auth',
            meta: {
                title: 'Авторизация вк',
            }
        },
        {
            path: '/shorts', component: () => import('./components/video/Reels'),
            name: 'shorts.index',
            meta: {
                title: 'Короткие ролики',
            }
        },
        {
            path: '/shorts/lenta/:id', component: () => import('./components/video/Shorts_lenta'),
            name: 'shorts.lenta.view',
            props: true,
            meta: {
                title: 'Ролик',
            }
        },
        {
            path: '/shorts/:id', component: () => import('./components/video/Rview'),
            name: 'shorts.view',
            props: true,
            meta: {
                title: 'Ролик',
            }
        },
         {
            path: '/apanel', component: () => import('./components/admin/Index'),
            name: 'admin.index',
            meta: {
                title: 'Управление',
            }
        },
         {
            path: '/apanel/group/:id', component: () => import('./components/admin/Group'),
            name: 'admin.group',
            props: true,
            meta: {
                title: 'Управление группой',
            }
        },
        {
            path: '/invite', component: () => import('./components/app/wedding/Index'),
            name: 'wedding.index',
            meta: {
                title: 'Приглашение',
            }
        },
        {
            path: '/wedding/cabinet', component: () => import('./components/user/Wedding'),
            name: 'wedding.cabinet',
            meta: {
                title: 'Кабинет',
            }
        },
        {
            path: '/wedding/apps', component: () => import('./components/app/wedding/Apps_list'),
            name: 'wedding.apps',
            meta: {
                title: 'Приложения',
            }
        },
        {
            path: '/cabinet/apps', component: () => import('./components/app/hb/Index'),
            name: 'cabinet.hb.apps',
            meta: {
                title: 'Управление приложениями',
            }
        },
        {
            path: '/wedding/guests', component: () => import('./components/user/modules/Guests'),
            name: 'wedding.guests',
            meta: {
                title: 'Кабинет',
            }
        },
         {
            path: '/wedding/tpl/:id', component: () => import('./components/app/wedding/Tpl_view'),
            name: 'wedding.tpl.view',
            props: true,
            meta: {
                title: 'Шаблон',
            }
        },
        {
            path: '/ainvite/:id', component: () => import('./components/app/wedding/Fast_auth'),
            name: 'wedding.auth.fast',
            props: true,
            meta: {
                title: 'Быстрая авторизация',
            }
        },
         {
            path: '/episodes', component: () => import('./components/episode/Lenta'),
            name: 'episode.lenta',
            meta: {
                title: 'Фото лента',
            }
        },
         {
            path: '/pwa-install/:iphone?', component: () => import('./components/app/Pwa_install'),
            name: 'pwa.install',
            meta: {
                title: 'Установка приложения',
            }
        },
         {
            path: '/video1/:filename', component: () => import('./components/app/Videoplayer'),
            name: 'index.videoplayer',
            props: true,
            meta: {
                title: 'Видеоплеер',
            }
        },
        {
            path: '/pay', component: () => import('./components/app/Payindex'),
            name: 'pay.index',
            meta: {
                title: 'О приложении',
            }
        },
         {
            path: '/pay/oferta', component: () => import('./components/app/pay/Oferta'),
            name: 'pay.oferta',
            meta: {
                title: 'Публичная оферта',
            }
        },
         {
            path: '/pay/politika', component: () => import('./components/app/pay/Politika'),
            name: 'pay.politika',
            meta: {
                title: 'Политика обработки персональных данных ',
            }
        },
         {
            path: '/pay/terms', component: () => import('./components/app/pay/Terms'),
            name: 'pay.terms',
            meta: {
                title: 'Пользовательское соглашение',
            }
        },
        {
            path: '*', component: () => import('./components/app/Page404'),
            name: 'page.404',
            meta: {
                title: 'Страница не найдена!',
            }
        },
        
    ]
})

router.beforeEach( (to, from, next) => {
    const main_screenWidth = window.screen.width
    const token = localStorage.getItem('x_xsrf_token')
    if(to.name == 'wedding.tpl.view' && !token){
        if(platform_type == 'wedding'){
                return next( {
                    name: 'page.404'
                })
        }
    }
    if((to.name == 'user.login' || to.name == 'user.signup') && token){
        if(main_screenWidth > 720){
            if(platform_type == 'shop'){
                return next( {
                    name: 'shop.index'
                })
            }else if(platform_type == 'market'){
                return next( {
                    name: 'market.index'
                })
            }else if(platform_type == 'payment'){
                return next( {
                    name: 'pay.index'
                })
            }
            return next( {
                name: 'lenta.index'
            })
        }
        return next( {
            name: 'main.index'
        })
    }else if((to.name == 'user.edit') && !token){ //есть не авторизован не пускаем
        return next( {
            name: 'user.login'
        })
    }else if((to.name == 'user.login' || to.name == 'user.signup') && !token && (platform_type == 1 || platform_type == 'oplata')){
        return next( {
            name: 'main.index'
        })
    }
    if(to.name == 'main.index' && main_screenWidth > 720 && platform_type != 1 && platform_type != 'oplata'){

        if(platform_type == 'shop'){
            return next( {
                name: 'shop.index'
            })
        }else if(platform_type == 'market'){
            return next( {
                name: 'market.index'
            })
        }else if(platform_type == 'wedding' || platform_type == 'birthday' || platform_type == 'babyparty' || platform_type == 'newyear'){
            return next( {
                name: 'wedding.index'
            })
        }else if(platform_type == 'kinder'){
            return next( {
                name: 'kinder.index'
            })
        }else if(platform_type == 'trc'){
            return next( {
                name: 'tc.index'
            })
        }else if(platform_type == 'payment'){
                return next( {
                    name: 'pay.index'
                })
        }else if(platform_type == 'photo'){
            return next( {
                name: 'messenger.index'
            })
        }
        return next( {
            name: 'lenta.index'
        })
    }else if(to.name == 'main.index' && main_screenWidth <= 720 && platform_type != 1 && platform_type != 'oplata'){
       if(platform_type == 'market'){
            return next( {
                name: 'markets.index'
            })
        }else if(platform_type == 'babygum' || platform_type == 'health'){
            return next( {
                name: 'menu.index'
            })
        }else if(platform_type == 'wedding' || platform_type == 'birthday' || platform_type == 'babyparty' || platform_type == 'newyear'){
            return next( {
                name: 'wedding.index'
            })
        }else if(platform_type == 'kinder'){
            return next( {
                name: 'kinder.index'
            })
        }else if(platform_type == 'trc'){
            return next( {
                name: 'tc.index'
            })
        }else if(platform_type == 'photo'){
            return next( {
                name: 'messenger.index'
            })
        }else if(platform_type == 'payment'){
                return next( {
                    name: 'pay.index'
                })
            }
    }else if(to.name == 'wedding.index' &&  platform_type == 'photo'){
        return next( {
                name: 'messenger.index'
            })
    }else if(to.name == 'menu.index' && main_screenWidth >= 720){
            return next( {
                name: 'lenta.index'
            })
    }
    if((to.name == 'messenger.open' || to.name == 'messenger.index' || to.name == 'app.index' || to.name == 'wedding.index' || to.name == 'kinder.index') && !token){
        return next( {
            name: 'user.login'
        })
    }
    const title = to.meta.title;
  document.title = title || 'Приложение'

    next()
    
    
})

export default router